<ng-container *ngIf="order">
  <p-dialog header="{{ 'ORDER_COMPLETED' | translate }}" [(visible)]="visible" [modal]="true"
    [style]="{ width: '30rem' }" (onHide)="onDialogHide()">
    <div>
      <h5 class="mb-3">{{ 'TIP_FOR_ORDER' | translate }} : {{ order.order_token }}</h5>
      <p style="font-size: 0.800rem; font-style: italic; font-weight: normal;">
         {{ locationLabel | translate }}: {{ displayAddress }}
      </p>
      <!-- Tip Section -->
      <div class="tipBx mt-4" *ngIf="!isCashPayment">
        <div class="d-flex gap-2 align-items-center mb-2">
          <input type="text" class="form-control h-35px" [(ngModel)]="customTip"
            [placeholder]="'ENTER_TIP_AMOUNT' | translate" min="0" />
          <button class="btn btn-primary h-35px py-2 px-4" (click)="selectTip()"
            [disabled]="tipSubmittedMap[order?.order_id] || (order?.payment?.tip > 0)">{{ 'CONFIRM'
            | translate }}</button>
        </div>
        <p class="w-100 badge badge-outline badge-success justify-content-center mb-5" *ngIf="selectedTip > 0 || (order?.payment?.tip > 0)">
          {{ 'TIP_GIVEN_TO_DRIVER' | translate }}: {{ selectedTip | currency }}
        </p>
      </div>
      <!-- Rating Section -->
      <div class="rateBx">
        <h5 class="mb-3">
          {{
          isHelperCategory
          ? ('RATE_YOUR_HELPER' | translate)
          : ('RATE_YOUR_DRIVER' | translate)
          }}
        </h5>
        <span class="d-flex gap-2">
          <ng-container *ngFor="let star of [].constructor(5); let i = index">
            <i class="fa text-primary" [ngClass]="{
     'fa-star': i < selectedRatingMap[order?.order_id] || i < ratingFromServer,
     'fa-star-o text-primary': i >= selectedRatingMap[order?.order_id] && i >= ratingFromServer
   }" [style.cursor]="ratingFromServer ? 'default' : 'pointer'"
              (click)="ratingFromServer ? null : (selectedRatingMap[order?.order_id] = i + 1)"
              style="font-size: 24px;"></i>

          </ng-container>
        </span>
        <div *ngIf="ratingFromServer > 0 && commentMap" class="mt-3">
          <h5 class="mb-3">{{ 'YOUR_COMMENT' | translate }}</h5>
          <p>{{ commentMap[order?.order_id] }}</p>
        </div>
        <div *ngIf="ratingFromServer === 0" class="mt-3">
          <textarea class="form-control" [(ngModel)]="commentMap[order?.order_id]"
            [placeholder]="'WRITE_YOUR_COMMENT' | translate" rows="3"></textarea>
        </div>
      </div>
      <div class="d-flex justify-content-center gap-2 mt-4">
        <button class="btn btn-primary py-2 px-4 my-2" (click)="saveRating()">{{ 'SAVE' | translate
          }}</button>
        <a (click)="skipRating()" class="btn btn-secondary py-2 px-4 my-2">{{ 'SKIP' | translate }}</a>
      </div>
    </div>
  </p-dialog>
</ng-container>
